import React from "react";
import "../css/returns.scss";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "No real transaction in this build",
    paragraphs: [
      "The current checkout is a simulation and does not take payment. Because no money changes hands, there is no real refund to issue. You can clear the local order and unlock record from the Privacy page.",
    ],
  },
  {
    title: "A future digital refund process",
    paragraphs: [
      "Before accepting real payment, anackmira should publish a reviewed process covering eligibility, how to request help, required order information, decision times and the effect of accessing digital content.",
    ],
  },
  {
    title: "Issues that should be reviewed",
    paragraphs: [
      "A production request may be appropriate when a purchased game cannot launch in a supported browser, the supplied digital content materially differs from its listing, a duplicate charge occurs, or applicable consumer law provides a remedy.",
    ],
    list: [
      "Game and edition purchased",
      "Order reference and contact email",
      "Browser and device details",
      "A concise description of the fault",
    ],
  },
  {
    title: "No blanket waiver",
    paragraphs: [
      "This draft does not claim that digital purchases are always non-refundable and does not limit mandatory consumer rights. Eligibility can depend on location, consent to immediate digital supply and whether access has begun.",
    ],
  },
  {
    title: "How to ask for help",
    paragraphs: [
      "Use the configured contact email and include the information above. Do not send card or bank information. Real response times and escalation routes must be confirmed before launch.",
    ],
  },
];
function Returns() {
  return (
    <PolicyPage
      kicker="Digital refunds"
      title="A fair path when play fails."
      summary="A pre-launch policy outline for browser-delivered game editions."
      sections={sections}
    />
  );
}
export default Returns;
